'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { existingUserSteps, tours } from 'DesignData/constants/Onboarding';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { EERIE } from 'HubStyleTokens/colors';

const i18nKey = key => `designManager.onboarding.existingUser.newFolderCreatedStep.${key}`;

class ExistingUserAfterNewFolderStep extends Component {
  constructor(props) {
    super(props);
    this.endOnboarding = this.endOnboarding.bind(this);
  }

  endOnboarding() {
    this.context.tour.finish();
  }

  renderContent() {
    return /*#__PURE__*/_jsxs("div", {
      className: "onboarding-popover-content",
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('header')
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('body')
        })
      })]
    });
  }

  renderHeader() {
    return /*#__PURE__*/_jsx(UICloseButton, {
      color: EERIE,
      onClick: this.endOnboarding,
      size: "medium"
    });
  }

  render() {
    return /*#__PURE__*/_jsx(UITourStep, {
      tourKey: tours.EXISTING_USER_IDE,
      stepKey: existingUserSteps.NEW_FOLDER_CREATED_STEP,
      className: "finder-onboarding-tooltip",
      content: {
        header: this.renderHeader(),
        body: this.renderContent()
      },
      placement: "right",
      width: 250,
      closeOnOutsideClick: false,
      children: this.props.children
    });
  }

}

ExistingUserAfterNewFolderStep.propTypes = {
  children: PropTypes.node
};
ExistingUserAfterNewFolderStep.contextType = TourContext;
ExistingUserAfterNewFolderStep.defaultProps = {
  children: /*#__PURE__*/_jsx("div", {})
};
export default ExistingUserAfterNewFolderStep;